import { InfoCircleOutlined } from '@ant-design/icons';
import CreateCustomerModal from 'components/UI/layout/components/emergencyInfos/CreateCustomerModal';
import { FC, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

const HasNoCustomer: FC = () => {
  //state
  const [showModal, setShowModal] = useState<boolean>(false);
  const { userProfile } = useSelector((state: RootState) => state.user);
  //effect
  useEffect(() => {
    if (userProfile && !userProfile.personId) setShowModal(true);
  }, [userProfile]);

  //functions
  const toggleShowModal = useCallback(() => setShowModal((prevState) => !prevState), []);

  return (
    <div className='mb-2 animate-pulse'>
      <div
        className='px-10 py-2 transition-shadow duration-300 rounded-lg shadow cursor-pointer bg-t-error-color text-t-opposite-text-color inherit-color hover:shadow-lg'
        onClick={toggleShowModal}>
        <span className='block text-sm font-medium'>
          <InfoCircleOutlined className='ml-2' />
          اطلاعات حساب تایید نشده
        </span>
        <span className='block text-xs text-center text-t-secondary-text-color'>جهت تکمیل کلیک کنید</span>
      </div>
      <CreateCustomerModal visible={showModal} close={toggleShowModal} />
    </div>
  );
};

export default HasNoCustomer;
